import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  inject,
} from "@angular/core";
import { ErrorMessageInterface } from "src/app/interfaces/error-message.interface";
import { SetEventInterface } from "src/app/interfaces/tagging.interface";
import { TaggingService } from "src/app/services/tagging.service";

declare function callSuperLine(): void;
@Component({
    selector: "app-dialog-error",
    templateUrl: "./dialog-error.component.html",
    styleUrls: ["./dialog-error.component.scss"],
    standalone: false
})
export class DialogErrorComponent implements OnInit {
  public data: any;

  get call(): boolean {
    const codes = ['RC_0005', ''];
    return codes.includes(this._data.code);
  }

  @Input() _data: ErrorMessageInterface;

  @Output() close = new EventEmitter<boolean>();

  #taggingService = inject(TaggingService);

  closeDialog(): void {
    
    if (this.call) {
      try {
        callSuperLine();
      } catch (error) {
        console.log(error, 'callSuperLine');
      }
    }
    this.close.emit(true);
    if (this.data?.close) {
      this.data.close(true);
    }
  }

  ngOnInit(): void {
    if (this.data) {
      this._data = this.data?._data;
    }
    if (this._data?.skipTagging) {
      return;
    }
    const currencyPath = window.location.pathname;
    const pathTaggeo = this.#taggingService.errorsFlows(currencyPath);
    const formattedString = this.formattedString(
      this._data.code,
      this._data.message
    );
    const action: SetEventInterface = {
      event: "payments",
      categoria: "error",
      accion: pathTaggeo,
      etiqueta: formattedString,
      canalBanco: "supermovil",
      userID: "",
    };

    this.#taggingService.setEvent(action);
  }

  formattedString(errorCode: string, errorMessage: string): string {
    let formattedString = errorCode + "_" + errorMessage.replace(/ /g, "_");
    return formattedString
      .toLocaleLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-`~()¿?¡!"']/g, "");
  }
}
